// 调证建议页面翻译
export default {
  // 页面标题
  title: "调证建议",

  // 按钮文本
  buttons: {
    uploadEvidence: "上传调证",
    reset: "重置",
    query: "查询",
    generateDocument: "生成文书",
    cancel: "取 消",
    upload: "上 传",
    confirm: "确 定",
    downloadTemplate: "下载模板",
  },

  // 导航链接
  navigation: {
    illustration: "调证说明",
    platform: "调证平台",
    flowPath: "调证流程",
  },

  // 对话框标题
  dialog: {
    illustration: "调证说明",
    platform: "调证平台",
    flowPath: "调证流程",
    uploadEvidence: "上传调证",
    downloadTemplate: "请点击要下载的模板",
    contactService: "联系客服",
  },

  // 建议列表页面 (suggestion.vue)
  suggestion: {
    // 搜索占位符
    placeholders: {
      content: "请输入调证内容",
      platform: "请选择调证平台",
      priority: "请选择调证优先级",
      status: "请选择调证状态",
      caseName: "请输入案件名称",
      userId: "请输入调证用户ID",
      userName: "请输入调证用户姓名",
    },

    // 表格
    table: {
      loading: "拼命加载中",
      totalPrefix: "共计",
      totalSuffix: "条数据",
      columns: {
        content: "调证内容",
        platform: "平台",
        priority: "优先级",
        status: "状态",
        relatedCase: "关联案件",
        reason: "调证原因",
        creator: "添加人",
        userId: "调证用户ID",
        userName: "调证用户姓名",
        createTime: "添加时间",
        operation: "操作",
      },
      actions: {
        delete: "删除",
      },
    },

    // 提示消息
    messages: {
      platformWarning: "当前仅支持批量选择同一平台的调证内容生产文书",
      deleteConfirm: "此操作将永久删除此条数据, 是否确定?",
      deleteTitle: "删除确认",
      deleteSuccess: "删除成功",
      deleteCancelled: "已取消删除",
      confirmButton: "确定",
      cancelButton: "取消",
    },
  },

  // 上传对话框 (uploadDialog.vue)
  upload: {
    // 说明标题
    instructionTitle: "调证上传说明",

    // 说明内容
    instructions: {
      line1:
        "1.当前调证文件解析支持的渠道有币安（Binance）、火币（Huobi）、火必（Huobi-HTX）、库币（KuCoin）、欧易（Okx）、抹茶（Mexc）、Bitget、比特派（Bitpie）、imToken、TokenPocket、BitgetWallet等几大主流交易所和钱包平台。",
      line2:
        "2.其他交易所文件，您可将文件上传至平台，平台后期将会开发该交易所文件解析，当前若要解析该调证文件，可联系我们。",
    },

    // 表单
    form: {
      platform: "平台",
      platformPlaceholder: "请选择(必填)",
      relatedCase: "关联案件 (非必填)",
      casePlaceholder: "下拉选择已有的案件",
      uploadFile: "上传调证文件",
      note: "注：当前版本仅支持解析xlsx格式的文件，若为csv格式的文件，请先转换为xls、xlsx格式的文件后再上传。",
    },

    // 联系客服
    contact: {
      instruction: "如需联系客服，请扫一扫下方二维码添加客服。",
      wechat: "微信",
    },

    // 上传成功
    success: {
      title: "调证文件已上传成功",
      message: "系统正在努力解析中,请耐心等待,稍后请刷新页面查看文件解析结果。",
    },
  },

  // 对话框文本 (dialogText.vue)
  dialogContent: {
    // 调证说明
    illustration: {
      p1: "1、区块链地址都是匿名的，无法直接知晓实控人身份。对涉案地址核验分析获得交易所线索后，可向交易所平台进行线索调证，以获取线索背后人员的身份信息、交易行为等数据。",
      p2: '2、在案件画布中，可对交易所线索数据一键加入调证建议，然后选择需要调证的内容一键生成调证文书，根据调证指引操作，让司法调证"不迷路"。',
      p3: '3、支持多家主流交易所、主流钱包公司调证文件上传解析。图示化展现冗杂的原始表格内容，让调证分析"不烦琐"。',
      p4: '4、使用人物分析ID在案件画布中直接扩展分析，灵活展示人物转账关系，让人物研判"不困难"。',
    },

    // 调证平台
    platform: {
      email: "调证邮箱：",
      subject: "建议调证邮箱标题：",
      attachments: "调证邮件附件材料：",
      notes: "其他注意事项：",
      noData: "暂无",
      noteItems: {
        note1: "1.去中心化钱包服务商的用户资产无法冻结",
        note2:
          "2.调证的数据范围时间范围尽量明确，建议是调取所有时长内的信息和操作记录",
        note3:
          "3.建议向平台明确调取的数据材料返回格式要为Excel，严禁图片和PDF格式",
        note4: "4.需要要求平台加盖公司电子公章，以便后续做证据固定使用",
        note5:
          "5.针对海外交易所，为提升调证的成功率，建议使用gov.cn等政府邮箱发送调证",
      },
    },

    // 调证流程
    flowPath: {
      step1: {
        title: "1、调证建议清单",
        content:
          "加入调证的数据会根据案件、调证平台等条件展示在调证建议页面，用户可在此页面查看并对所有调证建议的明细数据进行快捷操作。",
      },
      step2: {
        title: "2、生成调证文书",
        content:
          "选择当前所需调证的案件和平台，点击生成文书跳转至当前案件的调证数据详情，根据实际需要对调证数据进行操作，确认后可以批量生成调证文书。",
      },
      step3: {
        title: "3、下载调证文书模板",
        content:
          "下载调证文书模板并根据调证文书引导对内容进行完善后发送至对应调证平台。",
      },
      step4: {
        title: "4、上传调证文件",
        content:
          "收到平台返回的调证文件后，通过上传调证将调证文件上传至本系统中，系统将自动解析文件内容，用户可在调证文件中查看解析进度。",
      },
      step5: {
        title: "5、调证文件智能解析",
        content:
          "调证文件数据解析完成后，系统将自动同步数据，用户可在画布中使用人物分析ID直接扩展分析，层次化的展示方式将帮助用户更加高效、清晰、准确的进行案情研判。",
      },
    },
  },

  // 提示对话框 (Tips.vue)
  tips: {
    title: "提示",
    content:
      "当前版本暂不支持解析该交易所文件，您可将文件上传至平台，平台后期将会开发该交易所文件解析，当前若要解析该调证文件，可",
    contactUs: "联系我们",
    messages: {
      uploadSuccess: "上传原调证文件成功",
      uploadError: "上传失败，请刷新页面重新上传，或检查网络",
    },
  },

  // 文件上传组件 (newOssuplodefile.vue)
  ossUpload: {
    dragText: "点击或将文件拖拽到这里上传",
    supportText: "支持扩展名：.xls .xlsx",
    uploaded: "调证文件已上传",
    uploading: "上传中稍后......",
    uploadComplete: "上传已完成",
    messages: {
      uploadError: "上传失败，请稍后上传，或检查网络",
      uploadFailed: "上传失败，请刷新页面，重新上传",
      uploadFailedRefresh: "上传失败，请刷新页面重新上传，或检查网络",
      fileLimitWarning:
        "当前限制选择 20 个文件，本次选择了 {current} 个文件，共选择了 {total} 个文件",
    },
  },

  // 调证文书页面 (Documentfile.vue)
  documentFile: {
    title: "调证文书",
    downloadButton: "下载调证文书",
    preview: "调证文书预览",
    methodDescription: "调证方式说明",
    loading: "拼命加载中",
    fileName: "调取证据通知书",
    fields: {
      email: "调证邮箱：",
      emailTitle: "建议调证邮箱标题：",
      attachments: "调证邮件附件材料：",
      notes: "其他注意事项：",
      noData: "暂无",
    },
    notesList: {
      note1: "1.去中心化钱包服务商的用户资产无法冻结",
      note2:
        "2.调证的数据范围时间范围尽量明确，建议是调取所有时长内的信息和操作记录",
      note3:
        "3.建议向平台明确调取的数据材料返回格式要为Excel，严禁图片和PDF格式",
      note4: "4.需要要求平台加盖公司电子公章，以便后续做证据固定使用",
      note5:
        "5.针对海外交易所，为提升调证的成功率，建议使用gov.cn等政府邮箱发送调证",
    },
  },

  // 调证用户列表 (querysuspectser.vue)
  surveyUserList: {
    title: "调证用户",
    placeholders: {
      userId: "请输入用户ID",
      name: "请输入姓名",
      phone: "请输入手机号",
      email: "请输入邮箱",
      platform: "请选择调证平台",
      idNumber: "请输入证件号",
      caseName: "请输入案件名称",
      homePlace: "请输入籍贯",
    },
    buttons: {
      reset: "重置",
      query: "查询",
      relateCase: "关联案件",
      view: "查看",
      surveyReport: "调证报告",
    },
    table: {
      total: "共计",
      dataUnit: "条数据",
      loading: "拼命加载中",
      columns: {
        userAnalysisId: "用户分析ID",
        name: "姓名",
        sex: "性别",
        idNumber: "证件号",
        homePlace: "籍贯",
        email: "邮箱",
        phone: "手机号",
        relatedCase: "关联案件",
        operation: "操作",

        age: "年龄",
      },
      sex: {
        unknown: "未知",
      },
    },
    messages: {
      caseUpdateSuccess: "案件修改成功",
      copySuccess: "复制成功",
    },
  },
  caseRelation: {
    title: "关联案件",
    info: {
      title: "用户关联案件说明：",
      description:
        "可自行将调证用户与本人案件进行关联，关联案件后对应案件中会显示对应调证用户数据，以便于对调证数据进行管理和分析。",
    },
    form: {
      caseLabel: "关联案件:",
      casePlaceholder: "请选择关联案件",
    },
    validation: {
      caseRequired: "请选择关联案件",
    },
    buttons: {
      reset: "重置",
      submit: "提交",
    },
  },

  // 调证报告 (surveyReport.vue)
  surveyReport: {
    title: "调证报告",
    buttons: {
      preview: "生成报告",
      cancel: "取消",
    },
    loading: "拼命加载中",
    sections: {
      summary: "调证总结",
      personalInfo: "调证对象个人信息",
      accountBalance: "账户余额情况",
      otcTransaction: "OTC交易概况",
      depositWithdrawal: "充提交易概况",
      blockchainDeposit: "链上充币-币种汇总",
      blockchainWithdraw: "链上提币-币种汇总",
      internalDeposit: "内部充币-币种汇总",
      internalWithdraw: "内部提币-币种汇总",
      keyAddress: "交易关键地址(非必填)",
      loginIp: "登录IP统计",
      usedAddress: "使用过的地址",
      userBehavior: "用户行为",
    },
    table: {
      // 个人信息表格
      personalInfo: {
        name: "姓名",
        sex: "性别",
        nationality: "国籍",
        phone: "手机号",
        idNumber: "证件号",
        email: "邮箱",
        registerTime: "注册时间",
      },
      // 账户余额表格
      balance: {
        currency: "币种",
        balance: "余额",
        usdtBalance: "折合USDT",
        accountType: "账户类型",
        usdtAmount: "余额（USDT）",
      },
      // OTC交易表格
      otc: {
        direction: "交易方向",
        count: "交易次数",
        legalTender: "法币类型",
        totalAmount: "总数量",
        currency: "币种",
        tradeAmount: "交易数量",
        buy: "买入",
        sell: "卖出",
      },
      // 充提交易表格
      deposit: {
        currency: "币种",
        depositCount: "充币次数",
        depositAmount: "充币数量",
        withdrawCount: "提币次数",
        withdrawAmount: "提币数量",
        usdtAmount: "折合USDT",
        timeRange: "时间范围",
      },
      // 登录IP表格
      loginIp: {
        ipAddress: "IP地址",
        location: "IP地理位置",
        loginCount: "登录次数",
        lastLoginTime: "最近登录时间",
      },
      // 地址表格
      address: {
        blockchain: "链",
        address: "地址",
      },
      // 用户行为表格
      behavior: {
        action: "交易行为",
        direction: "交易方向",
        amount: "数量",
        currency: "币种",
        time: "时间",
        deposit: "充值",
        withdraw: "提现",
        buy: "买入",
        sell: "卖出",
      },
    },
    tips: {
      selectModule: "下方模块可选择",
      selectAll: "全选",
      legalTenderSummary: "法币汇总",
      virtualCurrencySummary: "虚拟币汇总",
      keyAddressPlaceholder: "交易关键地址(非必填)",
      usedAddressCount: "该账户使用过的交易所地址：",
      usedAddressTotal: "共{count}个",
      recentBehaviorNote: "只显示该用户最近操作的20条",
      noData: "暂无数据",
      notInvolved: "当前调证不涉及此数据",
    },
    radioOptions: {
      all: "全部",
      recentYear: "近一年",
      recent20: "近20条",
      commonAddress: "常用链地址",
    },
  },

  // 调证报告预览 (surveyFilePreview.vue)
  surveyFilePreview: {
    title: "AI 智能研判报告",
    buttons: {
      assistance: "鉴定协助",
      edit: "编辑",
      download: "下载报告",
      downloading: "下载中",
      previousStep: "上一步",
    },
    loading: "拼命加载中",
    assistance: {
      publicAccount: "微信公众号",
      customerService: "微信客服",
      tip: "扫码关注微信公众号或者添加微信客服",
    },
  },
};
